import { formDataToObject, setDialog, setSnackbar } from '@shared/library';
import axios, { AxiosError } from 'axios';
import React from 'react';
import config from './../../../../../../../../config';
//COMPONENTS 
import GestSaveButton from '@shared/library/dist/components/gest/GestInputs/button/save/GestSaveButton';
import GestSelect from '@shared/library/dist/components/gest/GestInputs/select/GestSelect';
//MODELS
import { IGestSelectOption } from '@shared/library/dist/components/gest/GestInputs/select/GestSelectProps';
import { IPlanningCommonFormProps } from '../CreateImportListForm/CreateImportListForm';

const ChangeAssignedPlanForm = (props: IPlanningCommonFormProps) => {
    //STATES
    const [loading, setLoading] = React.useState(false);
    const assignmentForm = React.useRef<HTMLFormElement>(null);

    //METHODS
    /**add or assign interventions to existing plan*/
    const assignToPlan = (event: React.SubmitEvent<HTMLFormElement>) => {
        event.preventDefault();
        const planID = formDataToObject<{ planID: number; }>(assignmentForm.current)?.planID;

        if (planID && props.plan?.length) {
            setLoading(true);
            return axios.patch(`${config.api.internal}/WFM/Plan/${planID}/AssignInterventions`, { interventions: props.plan }, { withCredentials: true })
                .then(alldone => {
                    props.onSuccess();

                    setDialog(props.config);
                    setSnackbar(props.config, alldone ? { message: props.lang?.successfully_updated, severity: 'success' } : { message: `${props.lang?.successfully_updated}. Alcuni interventi non sono stati assegnati con successo`, severity: 'warning' });
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setSnackbar(props.config, { message: "Errore durante assegnazione degli interventi al piano selezionato", severity: 'error' });
                })
                .finally(() => setLoading(false));
        }
    };

    return <form ref={assignmentForm} onSubmit={assignToPlan} style={{ flexDirection: "row" }}>
        <GestSelect
            name='planID'
            label={props.lang?.plan_name}
            options={props.existingPlans?.map<IGestSelectOption<undefined>>(p => ({ value: p.id, label: p.name }))}
            w={340}
            required
            disabled={loading}
        />

        <GestSaveButton
            submit
            h={30}
            label={props.lang.save}
            loading={loading}
        />
    </form>;
};
export default React.memo(ChangeAssignedPlanForm);